import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { TemplateDraft as Entity, FinalizeTemplateDraftResult } from './template-draft.model';
import { Template } from '../template/template.model';

export interface TemplateDraftState extends EntityState<Entity> {
    isLoading: boolean;
    error: Error | undefined;
    currentEntityId: number | undefined;
    currentCategoryId: number | undefined;
    history: { correlationId: string; payload: Entity | Entity[] | number | Template[] | FinalizeTemplateDraftResult | null }[];
}

export const templateDraftEntityAdapter: EntityAdapter<Entity> = createEntityAdapter<Entity>({
    selectId: (entity: Entity) => entity.id
});

export const initialState: TemplateDraftState = templateDraftEntityAdapter.getInitialState({
    isLoading: false,
    error: undefined,
    currentEntityId: undefined,
    currentCategoryId: undefined,
    history: []
});
